// extracted by mini-css-extract-plugin
export var image = "_ig-0";